import { render, staticRenderFns } from "./SocialAgentTable.vue?vue&type=template&id=65425c93&"
import script from "./SocialAgentTable.vue?vue&type=script&lang=js&"
export * from "./SocialAgentTable.vue?vue&type=script&lang=js&"
import style0 from "./SocialAgentTable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports